var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTruetwinVtr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57511 4.44467C9.43 4.3645 9.25459 4.36148 9.1068 4.43659L0.773461 8.67188C0.602934 8.75855 0.496799 8.93492 0.500073 9.12618C0.503347 9.31744 0.615456 9.49007 0.788849 9.57085L9.12218 13.4532C9.26125 13.518 9.42235 13.5153 9.55922 13.446L17.2259 9.56369C17.3911 9.48 17.4966 9.31181 17.4999 9.12661C17.5033 8.9414 17.4039 8.76953 17.2418 8.67996L9.57511 4.44467Z",
    stroke: "#D9D9D9",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57511 0.562342C9.43 0.482178 9.25459 0.479152 9.1068 0.554264L0.773461 4.78956C0.602934 4.87623 0.496799 5.05259 0.500073 5.24385C0.503347 5.43511 0.615456 5.60774 0.788849 5.68852L9.12218 9.57088C9.26125 9.63566 9.42235 9.63302 9.55922 9.56371L17.2259 5.68136C17.3911 5.59768 17.4966 5.42949 17.4999 5.24428C17.5033 5.05908 17.4039 4.88721 17.2418 4.79764L9.57511 0.562342Z",
    fill: "#CCF54E",
    stroke: "#CCF54E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruetwinVtr);
export default __webpack_public_path__ + "static/media/icon-truetwin-vtr.1dad310fe75640173b6020f9e22f2f44.svg";
export { ForwardRef as ReactComponent };